/** API 枚举 ↔ 前端模型转换 */

export const PROJECT_TYPE = { SITE: 1, BLD: 2 }
export const BUILDING_TYPE = { AREA: 1, BLD: 2 }
/** 楼栋在总平面上的框选区域存于隐藏楼层（Building 接口无 point_data） */
export const BUILDING_PLAN_FOOTPRINT_FLOOR_NAME = '__总图定位__'

export function isBuildingPlanFootprintFloor(floor) {
  const name = typeof floor === 'string' ? floor : (floor && floor.name)
  return String(name || '') === BUILDING_PLAN_FOOTPRINT_FLOOR_NAME
}
export const ONLINE = { ON: 1, OFF: 2 }

export function parseFloorNo(name) {
  if (!name) return 1
  const m = String(name).match(/(\d+)/)
  return m ? parseInt(m[1], 10) : 1
}

export function roleIdToUi(roleId) {
  if (roleId === 1) return 'admin'
  if (roleId === 3) return 'subcontractor'
  return 'general'
}

export function roleUiToId(role) {
  if (role === 'admin') return 1
  if (role === 'subcontractor') return 3
  return 2
}

/** 当前用户可创建的下级管理员 role（UI 值） */
export function creatableAdminRole(user) {
  if (!user) return null
  if (user.role === 'admin') return 'general'
  if (user.role === 'general') return 'subcontractor'
  return null
}

export function roleUiLabel(role) {
  if (role === 'admin') return '超级管理员'
  if (role === 'general') return '总包管理员'
  if (role === 'subcontractor') return '分包管理员'
  return role || ''
}

export function canAccessSystemSettings(user) {
  return !!(user && (user.role === 'admin' || user.role === 'general'))
}

export function apiAdminToUi(a) {
  return {
    id: a.id,
    username: a.account,
    name: a.real_name,
    role: roleIdToUi(a.role_id),
    roleId: a.role_id,
    phone: a.mobile || '',
    companyName: a.company_name || '',
    projectIds: Array.isArray(a.project_ids) ? a.project_ids.slice() : []
  }
}

export function apiProjectToUi(p) {
  return {
    id: p.id,
    name: p.name,
    mode: p.type === PROJECT_TYPE.BLD ? 'bld' : 'site',
    lng: p.longitude,
    lat: p.latitude,
    planDwg: p.type === PROJECT_TYPE.BLD ? null : (p.plan_image_url ? { name: p.plan_image_url, url: p.plan_image_url } : null),
    regions: [],
    floors: [],
    buildingCount: Number(p.building_count) || 0,
    floorCount: Number(p.floor_count) || 0,
    baseStationCount: Number(p.base_station_count) || 0,
    planImageCount: Number(p.plan_image_count) || 0,
    onlineDeviceCount: Number(p.online_device_count) || 0
  }
}

export function uiProjectToAdd(form) {
  return {
    name: form.name.trim(),
    longitude: form.lng,
    latitude: form.lat,
    type: form.mode === 'bld' ? PROJECT_TYPE.BLD : PROJECT_TYPE.SITE,
    plan_image_url: form.mode === 'bld' ? '' : (form.planDwg ? (form.planDwg.url || form.planDwg.name || '') : '')
  }
}

export function uiProjectToUpdate(form) {
  const payload = { id: form.id }
  if (form.name) payload.name = form.name.trim()
  if (form.lng != null) payload.longitude = form.lng
  if (form.lat != null) payload.latitude = form.lat
  if (form.mode) payload.type = form.mode === 'bld' ? PROJECT_TYPE.BLD : PROJECT_TYPE.SITE
  if (form.mode === 'bld') {
    payload.plan_image_url = ''
  } else if (form.planDwg) {
    payload.plan_image_url = form.planDwg.url || form.planDwg.name || ''
  }
  return payload
}

export function apiBuildingToRegion(b) {
  return {
    id: b.id,
    type: b.type === BUILDING_TYPE.AREA ? 'area' : 'bld',
    name: b.name,
    pos: b.plan_x != null && b.plan_y != null ? [b.plan_x, b.plan_y] : null,
    pointData: b.point_data || '',
    dwg: null,
    floors: [],
    projectId: b.project_id
  }
}

export const PLAN_REGION_ID = '__plan__'

/** 工地型项目：将项目总平面图虚拟为列表首位的「总图」层级（纯前端，不改接口） */
export function buildPlanRegion(project) {
  if (!project || project.mode !== 'site') return null
  return {
    id: PLAN_REGION_ID,
    type: 'plan',
    name: '施工总图',
    pos: null,
    dwg: project.planDwg ? { ...project.planDwg } : null,
    floors: [],
    virtual: true
  }
}

export function apiFloorToAreaRegion(f) {
  return {
    id: f.id,
    type: 'area',
    name: f.name,
    pos: f.plan_x != null && f.plan_y != null ? [f.plan_x, f.plan_y] : null,
    pointData: f.point_data || '',
    dwg: f.plan_image_url ? { name: f.plan_image_url, url: f.plan_image_url } : null,
    floors: [],
    projectId: f.project_id
  }
}

export function apiFloorToUi(f) {
  const no = parseFloorNo(f.name)
  return {
    id: f.id,
    no,
    name: f.name,
    height: 3,
    dwg: f.plan_image_url ? { name: f.plan_image_url, url: f.plan_image_url } : null,
    buildingId: f.building_id || 0,
    projectId: f.project_id,
    planX: f.plan_x,
    planY: f.plan_y,
    pointData: f.point_data || ''
  }
}

export function apiJobTypeToUi(j) {
  return {
    id: j.id,
    name: j.name,
    color: j.color || '',
    creatorAccount: j.creator_account || '',
    updaterAccount: j.updater_account || '',
    createdAt: j.created_at || '',
    updatedAt: j.updated_at || ''
  }
}

export function apiAlarmToUi(a) {
  return {
    id: a.id,
    deviceName: a.device_name || '',
    deviceNo: a.device_no || '',
    projectId: a.project_id || 0,
    buildingId: a.building_id || 0,
    floorId: a.floor_id || 0,
    planX: a.plan_x,
    planY: a.plan_y,
    alarmType: Number(a.alarm_type) || 0,
    alarmReason: a.alarm_reason || '',
    reportedAt: a.reported_at || '',
    createdAt: a.created_at || ''
  }
}

export function apiDeviceToBeacon(d, ctx = {}) {
  if (!d) return null
  const building = ctx.buildings && ctx.buildings.find(b => b && b.id === d.building_id)
  const floor = ctx.floors && ctx.floors.find(f => f && f.id === d.floor_id)
  const project = ctx.projects && ctx.projects.find(p => p && p.id === d.project_id)
  const jobTypes = ctx.jobTypes || []
  const jobType = jobTypes.find(j => j.id === d.job_type_id)
  const lngLat = planToLngLat(project, d.plan_x, d.plan_y)
  return {
    id: d.id,
    mac: d.beacon_mac,
    name: d.name,
    mobile: d.mobile || '',
    jobTypeId: d.job_type_id || 0,
    jobTypeName: jobType ? jobType.name : '',
    major: d.major || '',
    color: d.color || '',
    zone: building ? building.name : '',
    bld: building ? building.id : 0,
    floor: floor ? parseFloorNo(floor.name) : 0,
    floorId: d.floor_id || 0,
    buildingId: d.building_id || 0,
    projectId: d.project_id || 0,
    status: d.online_status === ONLINE.ON ? 'online' : 'offline',
    onlineStatus: d.online_status,
    lng: lngLat.lng,
    lat: lngLat.lat,
    planX: d.plan_x,
    planY: d.plan_y,
    baseStationId: d.base_station_id || 0,
    lastLocationAt: d.last_location_at || '',
    creatorAccount: d.creator_account || '',
    updatedAt: d.updated_at || '',
    createdAt: d.created_at || ''
  }
}

export function apiBaseStationToUi(s, ctx = {}) {
  const project = ctx.projects && ctx.projects.find(p => p.id === s.project_id)
  const planX = s.plan_x != null ? s.plan_x : s.x
  const planY = s.plan_y != null ? s.plan_y : s.y
  const hasPoint = planX != null && planY != null
  const buildingId = s.building_id || 0
  const floorId = s.floor_id || 0
  const hasDwgBind = Number(s.project_id) > 0
  const lngLat = planToLngLat(project, hasPoint ? planX : null, hasPoint ? planY : null)
  return {
    id: s.id,
    deviceNo: s.device_no,
    name: s.name,
    projectId: s.project_id || null,
    buildingId,
    floorId,
    zone: '',
    floor: floorId || 0,
    configured: hasPoint,
    status: s.status,
    online: s.online_status === ONLINE.ON,
    onlineStatus: s.online_status,
    lng: lngLat.lng,
    lat: lngLat.lat,
    planX: hasPoint ? planX : null,
    planY: hasPoint ? planY : null,
    dwellLimitMinutes: Number(s.dwell_limit_minutes) || 0,
    entranceType: Number(s.beacon_type != null ? s.beacon_type : s.entrance_type) || 0,
    lastReportAt: s.last_report_at || '',
    creatorAccount: s.creator_account || '',
    updatedAt: s.updated_at || '',
    createdAt: s.created_at || '',
    bind: hasDwgBind
      ? {
        dwgKey: buildDwgKey(s.project_id, buildingId, floorId),
        regionId: buildingId || null,
        floorId: floorId || null,
        floorNo: null,
        x: hasPoint ? planX : null,
        y: hasPoint ? planY : null,
        hasPoint
      }
      : null
  }
}

export function buildDwgKey(projectId, buildingId, floorId) {
  if (!projectId) return ''
  if (!buildingId && !floorId) return `${projectId}:plan`
  if (!floorId) return `${projectId}:${buildingId}`
  return `${projectId}:${buildingId}:${floorId}`
}

export function planToLngLat(project, planX, planY) {
  if (!project || planX == null || planY == null) {
    return {
      lng: project ? (project.lng != null ? project.lng : project.longitude) : 114.057,
      lat: project ? (project.lat != null ? project.lat : project.latitude) : 22.543
    }
  }
  const lng = Number(project.lng != null ? project.lng : project.longitude)
  const lat = Number(project.lat != null ? project.lat : project.latitude)
  const scale = 0.00008
  return {
    lng: +(lng + (planX - 50) * scale).toFixed(6),
    lat: +(lat - (planY - 50) * scale).toFixed(6)
  }
}

export function trackStopToPoint(stop, idx, project) {
  const lngLat = planToLngLat(
    project ? { lng: project.longitude, lat: project.latitude } : null,
    stop.plan_x,
    stop.plan_y
  )
  const start = stop.stop_start_time ? new Date(stop.stop_start_time) : new Date()
  const end = stop.stop_end_time ? new Date(stop.stop_end_time) : start
  return {
    time: formatTime(start),
    endTime: formatTime(end),
    lng: lngLat.lng,
    lat: lngLat.lat,
    zoneName: stop.building_name || stop.project_name || '',
    bld: stop.building_id || 0,
    floor: parseFloorNo(stop.floor_name),
    floorId: stop.floor_id,
    desc: stop.base_station_name || stop.base_station_mac || '停靠点',
    baseStationMac: stop.base_station_mac || '',
    baseStationName: stop.base_station_name || '',
    duration: stop.stop_duration_seconds || 0,
    planX: stop.plan_x,
    planY: stop.plan_y,
    projectId: stop.project_id,
    buildingId: stop.building_id || 0,
    idx
  }
}

function formatTime(d) {
  const p = n => String(n).padStart(2, '0')
  return `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
}

export function assembleProjectTree(projects, buildings, floors) {
  return projects.map(p => {
    const ui = apiProjectToUi(p)
    const pBuildings = buildings.filter(b => b.project_id === p.id)
    const pFloors = floors.filter(f => f.project_id === p.id)

    if (ui.mode === 'bld') {
      ui.floors = pFloors
        .filter(f => !f.building_id)
        .map(f => apiFloorToUi(f))
        .sort((a, b) => a.no - b.no)
    } else {
      const bldBuildings = pBuildings.filter(b => b.type === BUILDING_TYPE.BLD)
      const areaFloors = pFloors.filter(f => !f.building_id)
      const areaRegions = areaFloors.map(f => apiFloorToAreaRegion(f))
      const bldRegions = bldBuildings.map(b => {
        const region = apiBuildingToRegion(b)
        const buildingFloors = pFloors.filter(f => f.building_id === b.id)
        const footprint = buildingFloors.find(f => isBuildingPlanFootprintFloor(f))
        // Building 接口已有 point_data 时优先用；否则回退隐藏 Floor（过渡期兼容）
        if (!region.pointData && footprint && footprint.point_data) {
          region.pointData = footprint.point_data
        }
        if ((!region.pos || region.pos.length < 2) && footprint
          && footprint.plan_x != null && footprint.plan_y != null) {
          region.pos = [footprint.plan_x, footprint.plan_y]
        }
        region.floors = buildingFloors
          .filter(f => !isBuildingPlanFootprintFloor(f))
          .map(f => apiFloorToUi(f))
          .sort((a, c) => a.no - c.no)
        return region
      })
      ui.regions = [...areaRegions, ...bldRegions]
    }
    return ui
  })
}

export function buildingsToZones(buildings, projects) {
  return buildings.map(b => {
    const project = projects.find(p => p.id === b.project_id)
    const lngLat = planToLngLat(
      project ? { lng: project.longitude, lat: project.latitude } : null,
      b.plan_x,
      b.plan_y
    )
    return {
      id: String(b.id),
      name: b.name,
      lng: lngLat.lng,
      lat: lngLat.lat,
      type: b.type,
      projectId: b.project_id,
      blds: b.type === BUILDING_TYPE.BLD
        ? [{ id: b.id, floors: b.floor_count || 1, heights: {} }]
        : [{ id: 1, floors: b.floor_count || 1, heights: {} }]
    }
  })
}
